import type { FileStorage } from "./api";

export class OpfsStorage implements FileStorage {
  constructor(protected fileSystemDirectoryHandle: FileSystemDirectoryHandle) {}

  async saveData(data: ArrayBuffer, fileName: string) {
    try {
      const fileHandle = await this.fileSystemDirectoryHandle.getFileHandle(
        fileName,
        { create: true },
      );

      const writable = await fileHandle.createWritable();

      await writable.write(data);
      await writable.close();
      console.log(`Successfully written file: ${fileName} to cache`);
    } catch (error) {
      console.error(`Failed to save ${fileName}:`, error);
      throw error;
    }
  }

  async loadData(
    fileName: string,
    loggingEnabled = true,
  ): Promise<ArrayBuffer | null> {
    try {
      const loadStart = performance.now();
      const fileHandle =
        await this.fileSystemDirectoryHandle.getFileHandle(fileName);
      const file = await fileHandle.getFile();

      if (loggingEnabled) {
        console.log(
          `loaded: ${fileName} with size: ${file.size} from opfs cache in ${performance.now() - loadStart}`,
        );
      }

      return file.arrayBuffer();
    } catch (error) {
      if ((error as Error).name === "NotFoundError") {
        return null;
      }
      console.error(`Failed to read ${fileName}:`, error);
      throw error;
    }
  }

  async deleteFile(fileName: string): Promise<void> {
    try {
      await this.fileSystemDirectoryHandle.removeEntry(fileName);
      console.log(`Successfully removed ${fileName} from cache`);
    } catch (error) {
      console.error(`Failed to delete ${fileName}:`, error);
      throw error;
    }
  }
}
